import { ApprovalItem } from '../../services/approvalService';
import { ApprovalData } from './types';

export const transformApiDataToUI = (apiItem: ApprovalItem): ApprovalData => {
    return {
        id: apiItem.id,
        status:
            apiItem.status === 'pending'
                ? 'Pending'
                : apiItem.status === 'reviewed'
                  ? 'Review Passed'
                  : apiItem.status === 'approved'
                    ? 'Approved'
                    : apiItem.status === 'failed'
                      ? 'Review Failed'
                      : apiItem.status === 'rejected'
                        ? 'Rejected'
                        : 'Pending',
        fullName: `${apiItem.name} ${apiItem.surname}`,
        incidentNumber: apiItem.indigent_number,
        personalId: apiItem.sa_id,
        electricityMeterNo: apiItem.electricity_meter_no || 'N/A',
        accountNumber: apiItem.account_number,
        employerName: apiItem.employer_name || 'N/A',
        cellNumber: apiItem.cell_number || 'N/A',
        email: apiItem.email?.trim() ? apiItem.email.trim() : 'N/A',
        monthlyIncome: apiItem.monthly_income?.toString() || 'N/A',
        wardNo: apiItem.ward_no || 'N/A',
        financialYear: apiItem.financial_year.toString(),
        erfNo: apiItem.erf_no || 'N/A',
        scannedDocs: apiItem.attachments.map(att => att.file_path),
        // Additional API fields
        submittedBy: apiItem.submitted_by,
        updatedBy: apiItem.updated_by,
        submittedByUsername: apiItem.submitted_by_username,
        createdAt: apiItem.created_at,
        updatedAt: apiItem.updated_at,
        approvedBy: apiItem.approved_by,
        approvedAt: apiItem.approved_at,
        rejectedBy: apiItem.rejected_by,
        rejectedAt: apiItem.rejected_at,
        reviewRemark: apiItem.review_remark,
        // Map reviewer information fields - these are the fields the UI expects
        approved_by_username: apiItem.approved_by_username,
        rejected_by_username: apiItem.rejected_by_username,
        review_passed_by_username: apiItem.review_passed_by_username,
        review_failed_by_username: apiItem.review_failed_by_username,
        approved_at: apiItem.approved_at,
        rejected_at: apiItem.rejected_at,
        review_passed_at: apiItem.review_passed_at,
        review_failed_at: apiItem.review_failed_at,
        occupants: apiItem.occupants.map(occ => ({
            name: occ.name,
            surname: occ.surname,
            personalId: occ.personal_id,
            employerName: occ.employer_name,
            monthlyIncome: occ.monthly_income,
            cellNumber: occ.cell_number,
            id: occ.id,
            requestId: occ.request_id,
            photoPath: occ.photo_path,
        })),
        attachments: apiItem.attachments.map(att => ({
            id: att.id,
            requestId: att.request_id,
            filename: att.filename,
            filePath: att.file_path,
            fileType: att.file_type,
            documentType: att.document_type,
            uploadedBy: att.uploaded_by,
            uploadedAt: att.uploaded_at,
        })),
    };
};
